/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Input, OnChanges, OnInit, Optional, SimpleChanges} from '@angular/core';
import {MdDialogRef} from './dialog-ref';
import {MdDialogContainer} from './dialog-container';
/**
 * Counter used to generate unique IDs for dialog elements.
 */
let dialogElementUid = 0;
/**
 * Button that will close the current dialog.
 */
export class MdDialogClose implements OnChanges {
/**
 * Screenreader label for the button.
 */
ariaLabel: string = 'Close dialog';
/**
 * Dialog close input.
 */
dialogResult: any;

   _matDialogClose: any;
   _mdDialogClose: any;
   _matDialogCloseResult: any;
/**
 * @param {?} dialogRef
 */
constructor(public dialogRef: MdDialogRef<any>) { }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    const /** @type {?} */ proxiedChange = changes._matDialogClose || changes._mdDialogClose ||
        changes._matDialogCloseResult;

    if (proxiedChange) {
      this.dialogResult = proxiedChange.currentValue;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `button[md-dialog-close], button[mat-dialog-close],
             button[mdDialogClose], button[matDialogClose]`,
  host: {
    '(click)': 'dialogRef.close(dialogResult)',
    '[attr.aria-label]': 'ariaLabel',
    'type': 'button', // Prevents accidental form submits.
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ariaLabel': [{ type: Input, args: ['aria-label', ] },],
'dialogResult': [{ type: Input, args: ['md-dialog-close', ] },],
'_matDialogClose': [{ type: Input, args: ['matDialogClose', ] },],
'_mdDialogClose': [{ type: Input, args: ['mdDialogClose', ] },],
'_matDialogCloseResult': [{ type: Input, args: ['mat-dialog-close', ] },],
};
}

function MdDialogClose_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogClose.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogClose.ctorParameters;
/** @type {?} */
MdDialogClose.propDecorators;
/**
 * Screenreader label for the button.
 * @type {?}
 */
MdDialogClose.prototype.ariaLabel;
/**
 * Dialog close input.
 * @type {?}
 */
MdDialogClose.prototype.dialogResult;
/** @type {?} */
MdDialogClose.prototype._matDialogClose;
/** @type {?} */
MdDialogClose.prototype._mdDialogClose;
/** @type {?} */
MdDialogClose.prototype._matDialogCloseResult;
/** @type {?} */
MdDialogClose.prototype.dialogRef;
}

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
export class MdDialogTitle implements OnInit {
   id = `md-dialog-title-${dialogElementUid++}`;
/**
 * @param {?} _container
 */
constructor(
private _container: MdDialogContainer) { }
/**
 * @return {?}
 */
ngOnInit() {
    if (this._container && !this._container._ariaLabelledBy) {
      Promise.resolve().then(() => this._container._ariaLabelledBy = this.id);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-dialog-title], [mat-dialog-title], [mdDialogTitle], [matDialogTitle]',
  host: {
    'class': 'mat-dialog-title',
    '[id]': 'id',
  },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogContainer, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
};
}

function MdDialogTitle_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogTitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogTitle.ctorParameters;
/** @type {?} */
MdDialogTitle.propDecorators;
/** @type {?} */
MdDialogTitle.prototype.id;
/** @type {?} */
MdDialogTitle.prototype._container;
}

/**
 * Scrollable content container of a dialog.
 */
export class MdDialogContent { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `[md-dialog-content], md-dialog-content, [mat-dialog-content], mat-dialog-content,
             [mdDialogContent], [matDialogContent]`,
  host: {'class': 'mat-dialog-content'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogContent_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogContent.ctorParameters;
}

/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
export class MdDialogActions { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `[md-dialog-actions], md-dialog-actions, [mat-dialog-actions], mat-dialog-actions,
             [mdDialogActions], [matDialogActions]`,
  host: {'class': 'mat-dialog-actions'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogActions_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogActions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogActions.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
